import { transformSpotlights } from '@/common/integrations/menhir/employee/spotlights/spotlights.dto';
import { TMenhirSpotlights } from '@/common/integrations/menhir/employee/spotlights/spotlights.types';
import { menhirClient } from '@/common/integrations/menhir/menhir.client';
import { MENHIR_ENDPOINTS } from '@/common/integrations/menhir/menhir.endpoints';
import { AxiosRequestConfig } from 'axios';

export const getSpotlights = (config?: AxiosRequestConfig) => {
  return menhirClient
    .get<
      null,
      {
        spotlights: TMenhirSpotlights;
      }
    >(MENHIR_ENDPOINTS.EMPLOYEE.SPOTLIGHTS, config)
    .then((envelope) => {
      return transformSpotlights(envelope.spotlights);
    });
};
